import {
  Directive,
  Inject,
  Input,
  Optional,
  SkipSelf,
  forwardRef,
} from '@angular/core';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export const MONTH_YEAR_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Directive({
  selector: '[phoenixMonthYearFormat]',
  standalone: true,
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useExisting: forwardRef(() => MonthYearFormatDirective),
    },
  ],
})
export class MonthYearFormatDirective {
  @Input('phoenixMonthYearFormat') config:
    boolean | string | MatDateFormats | undefined | null;

  constructor(
    @Optional()
    @SkipSelf()
    @Inject(MAT_DATE_FORMATS)
    private readonly parentFormats: MatDateFormats | null
  ) {}

  get parse() {
    return (this.activeFormats || this.parentFormats || MONTH_YEAR_FORMATS)
      .parse;
  }

  get display() {
    return (this.activeFormats || this.parentFormats || MONTH_YEAR_FORMATS)
      .display;
  }

  private get activeFormats(): MatDateFormats | null {
    if (
      this.config === true ||
      this.config === '' ||
      this.config === undefined
    ) {
      return MONTH_YEAR_FORMATS;
    }
    if (typeof this.config === 'object' && this.config !== null) {
      return this.config;
    }
    return null;
  }
}
